<template>
  <div>
    <v-menu offset-y
            max-width="320">
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon
                   v-bind="attrs"
                   v-bind:aria-label="$t('language')"
                   v-on="{ ...tooltip, ...menu }">
              <v-icon v-bind:color="color">mdi-translate</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('language') }}</span>
        </v-tooltip>
      </template>
      <v-list class="py-0">
        <v-list-item two-line
                     v-bind:key="locale.id"
                     v-for="locale in locales"
                     v-on:click="$emit('set-locale', { localeId: locale.id })">
          <v-list-item-content>
            <v-list-item-title>{{ locale.nativeTitle }}</v-list-item-title>
            <v-list-item-subtitle>{{ locale.title }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon class="align-self-center"
                            v-if="locale.id === currentLocaleId">
            <v-icon color="accent">mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'LocaleBlock',
    props: {
      color: String,
      currentLocaleId: String,
      locales: Array
    }
  }
</script>

<i18n>
  {
    "de": {
      "language": "Sprache"
    },
    "en": {
      "language": "Language"
    }
  }
</i18n>